import React, {
  createContext,
  useReducer,
  FC,
  Dispatch,
  useState,
  useEffect,
} from 'react';

import { Reducer, StateInterface } from './Reducers/Reducer';
import { auth } from '../Services/firebase';

const initialState = {
  isLoggedIn: false,
  showModal: false,
  address: [],
  defaultAddress: {
    id: 0,
    firstName: '',
    lastName: '',
    address1: '',
    address2: '',
    email: '',
    state: '',
    phone: '',
    pin: '',
  },
};

interface ContextProps {
  state: StateInterface;
  dispatch: Dispatch<any>;
  user: any
}

export const Context = createContext<ContextProps>({
  state: initialState,
  dispatch: () => null,
  user: null,
});

const ContextProvider: FC = ({
  children,
}) => {
  const [state, dispatch] = useReducer(Reducer, initialState);
  const [user, setUser] = useState<any>(null);

  useEffect(() => {
    auth.onAuthStateChanged((userAuth) => {
      setUser(userAuth);
    });
  }, []);

  return (
    <Context.Provider value={{ state, dispatch, user }}>
      {children}
    </Context.Provider>
  );
};

export default ContextProvider;
